import { Box } from '@mui/material';
import {
  createRootRoute,
  Outlet,
  redirect,
  useLocation
} from '@tanstack/react-router';

import { useToggle } from 'usehooks-ts';

import { AppBar, NavMenu } from '../components';
import { PUBLIC_PATHS } from '../consts';

const Root = () => {
  const location = useLocation();
  const [menuOpen, toggleMenu, setMenuOpen] = useToggle(false);

  if (PUBLIC_PATHS.includes(location.pathname)) {
    return <Outlet />;
  }

  const onLogout = () => {
    window
      .fetch('/api/v3/admin/auth/logout', {
        credentials: 'include',
        method: 'DELETE'
      })
      .then(() => {
        localStorage.removeItem('isAdmin');
        window.location.href = '/login';
      });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <AppBar onLogout={onLogout} onMenuToggle={toggleMenu} />
      <Box sx={{ display: 'flex', flexGrow: 1, overflow: 'hidden' }}>
        <NavMenu onClose={() => setMenuOpen(false)} open={menuOpen} />
        <Box
          component='main'
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            minWidth: 0,
            overflow: 'auto'
          }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export const Route = createRootRoute({
  beforeLoad: async ({ location }) => {
    if (PUBLIC_PATHS.includes(location.pathname)) return;

    const res = await window.fetch('/api/v3/auth/admin', {
      credentials: 'include'
    });

    /**
     * Only an actual auth rejection ends the session. A throttle 429 or a
     * 5xx from this check is transient, and treating it as a logout bounces
     * a signed-in admin to the login page mid-navigation.
     */
    if (res.status === 401 || res.status === 403) {
      throw redirect({ to: '/login' });
    }
  },
  component: Root
});
